import script from "./FixedPromoMessageItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FixedPromoMessageItem.vue?vue&type=script&setup=true&lang=js"

import "./FixedPromoMessageItem.vue?vue&type=style&index=0&id=01fd9554&lang=scss"

const __exports__ = script;

export default __exports__